import { Injectable, signal, WritableSignal } from '@angular/core';
import { TreeItem } from './tree.model';

@Injectable({
  providedIn: 'root'
})
export class TreeInteractionService {
  readonly editingItem: WritableSignal<TreeItem | null> = signal(null);
  private originalName: string | null = null;

  startEdit(item: TreeItem) {
    // If already editing, maybe cancel previous?
    if (this.editingItem()) {
      this.cancelEdit();
    }

    this.originalName = item.name;



    // Initialize updatedText with current edit state or name
    if (!item.isNew) {
      // janp commented this out item.updatedText = item.updatedText ?? item.name;
    }
    this.editingItem.set(item);
  }

  saveEdit() {
    const item = this.editingItem();
    if (item) {
      // Commit the updated text to the name
      // Clean up updatedText if it matches original
      if (item.updatedText === item.name) {
        item.updatedText = undefined;
      }

      // We do NOT commit to item.name, preserving the diff state.



      this.originalName = null;
      this.editingItem.set(null);
    }
  }

  cancelEdit() {
    const item = this.editingItem();
    if (item) {
      // Revert text change
      item.updatedText = undefined;

      // Recalculate isUpdated (might still be true due to properties)
      item.isUpdated = item.isNew || !!item.propertiesUpdated;

      this.originalName = null;
      this.editingItem.set(null);
    }
  }

  // Properties Popup State
  readonly propertiesItem: WritableSignal<{ item: TreeItem, event?: MouseEvent } | null> = signal(null);

  openProperties(item: TreeItem, event?: MouseEvent) {
    console.log('Opening properties for', item.id);
    this.propertiesItem.set({ item, event });
  }

  closeProperties() {
    this.propertiesItem.set(null);
  }
}
